import React from "react";
import PropTypes from "prop-types";
import Image from "../../../image/image";
import classNames from "classnames";
import DashedCorners from "@default/general-components/dashed-corners";

const ClickSuggestionTopic = ({ content, linkOrFilter }) => {
  const articleClassNames = classNames({
    "click-suggestion": true,
    "with-image": content.fieldImage,
    "no-image": !content.fieldImage,
  });

  return (
    <article
      className={articleClassNames}
      aria-label={`Element: ${linkOrFilter.title}`}
    >
      <DashedCorners modifier="bigger" />

      <div className="inner-wrapper">
        {content.fieldImage ? (
          <div className="background-image">
            <Image
              data={content.fieldImage.fieldMediaImage}
              credit={content.fieldImage.fieldCredits}
            />
          </div>
        ) : (
          <div className="color-wrapper background-image" />
        )}
        <div className="text-wrapper">
          <span className="headline headline-s">
            {linkOrFilter && <>{linkOrFilter.title}</>}
          </span>
        </div>
      </div>
    </article>
  );
};

ClickSuggestionTopic.propTypes = {
  content: PropTypes.shape({
    fieldImage: PropTypes.object,
    fieldLink: PropTypes.shape({
      url: PropTypes.shape({
        routed: PropTypes.bool,
        path: PropTypes.string,
      }),
    }),
  }),
};

export default ClickSuggestionTopic;
